import ReactCalendar from 'react-calendar';

import CalendarPopover from './components/CalendarPopover';

import './lib/Calendar.scss';

/**
 * @param {import('./lib/propTypes').CalendarProps} props
 */

const Calendar = (props) => {
  const { value, onChange, isPopover = false, isRange = false, className } = props;

  if (isPopover) return <CalendarPopover {...props} />;

  return (
    <ReactCalendar value={value} onChange={onChange} className={className} selectRange={isRange} />
  );
};

export default Calendar;
